import { useStoreState } from '@src/store/store';

export function useUser() {
  return useStoreState((store) => store.user);
}
